<template>
    <div class="sty-section" :class="bemFacets">
        <sty-overlay-root/>

        <div class="grid--container">
            <sty-header :facets="['section-title']">
                <h2 class="u-reset u-reset__sty" :id="anchor" v-text="sectionTitle"/>
            </sty-header>
        </div>

        <div class="grid--container">
            <div class="grid--row sty-section--articles">
                <div class="grid--col sty-section--article">
                    <sty-header>
                        <h3 class="u-reset u-reset__sty">
                            Overlay recipes
                        </h3>
                        <p>
                            Has scroll locking overlays: {{ hasScrollLockingOverlays }}
                        </p>
                    </sty-header>

                    <div class="grid--row">
                        <div class="grid--col sty-section--col">
                            <div class="sty-section--overlay-buttons">
                                <div class="sty-section--overlay-button">
                                    <button type="button"
                                            class="btn btn__medium btn__primary"
                                            @click.prevent="open('MODAL_CHOICE')">
                                        choice modal {{ wasAccepted }}
                                    </button>
                                </div>
                                <div class="sty-section--overlay-button">
                                    <button type="button"
                                            class="btn btn__medium btn__primary"
                                            @click.prevent="open('MODAL_BLOCKING')">
                                        blocking
                                    </button>
                                </div>
                                <div class="sty-section--overlay-button">
                                    <button type="button"
                                            class="btn btn__medium btn__primary"
                                            @click.prevent="open('MODAL_TOAST')">
                                        toast
                                    </button>
                                </div>
                                <div class="sty-section--overlay-button">
                                    <button type="button"
                                            class="btn btn__medium btn__primary"
                                            @click.prevent="open('MODAL_SIDEBAR')">
                                        sidebar
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { mapActions, mapGetters } from 'vuex';
    import * as invokeMethods from './helpers';
    import { INSTANCES, MODAL_CONFIG } from './overlay-instances';
    import StyHeader from 'framework/styleguide/header';
    import StyOverlayRoot from 'framework/styleguide/overlay-recipes/overlay-root/overlay-root';
    import StyOverlayRecipeDialog
        from 'framework/styleguide/overlay-recipes/overlay-recipe-dialog/overlay-recipe-dialog';
    import StyOverlayRecipeToast from 'framework/styleguide/overlay-recipes/overlay-recipe-toast/overlay-recipe-toast';
    import { bemMixin } from '@dreipol/vue-ui/src/mixins';

    Vue.component('StyOverlayRecipeDialog', StyOverlayRecipeDialog);
    Vue.component('StyOverlayRecipeToast', StyOverlayRecipeToast);

    export default {
        components: {
            StyOverlayRoot,
            StyHeader,
        },
        mixins: [
            bemMixin('sty-section'),
        ],
        props: {
            anchor: {
                type: String,
                required: true,
            },
            sectionTitle: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                wasAccepted: null,
            };
        },
        computed: {
            ...mapGetters('vue-ui/overlay', ['hasScrollLockingOverlays']),
        },
        methods: {
            ...mapActions('vue-ui/overlay', ['openOverlay', 'closeOverlay']),
            open(type) {
                const { fn, props, facets } = MODAL_CONFIG[type];

                const Feedback = invokeMethods[fn](this.openOverlay, props, facets);

                if (Feedback) {
                    Feedback.then(
                        () => {
                            console.log('Accepted! Closing overlay...');
                            this.wasAccepted = '(accepted)';
                            this.closeOverlay({ id: INSTANCES.MODAL, transition: 'trs-simple-fade' });
                        },
                        () => {
                            console.log('Declined! Closing overlay...');
                            this.wasAccepted = '(declined)';
                            this.closeOverlay({ id: INSTANCES.MODAL, transition: 'trs-simple-fade' });
                        },
                    );
                }

                if (['MODAL_BLOCKING'].includes(type)) {
                    setTimeout(() => {
                        this.closeOverlay({ id: INSTANCES.MODAL, transition: 'trs-simple-fade' });
                    }, 5000);
                }
            },
        },
    };
</script>
